angular
  .module('contabilidad.catalogosexternos')
  .service(
    'CatalogosExternosSucursalCuentasContables',
    CatalogosExternosSucursalCuentasContables,
  )

  CatalogosExternosSucursalCuentasContables.$inject = ['$http']

function CatalogosExternosSucursalCuentasContables ($http) {
  this.get = get
  this.put = put
  this.post = post

  function get (id_sucursal) {
    return $http.get('/api/contabilidad/cuentas-contables/sucursal',{
        params: {
          id_sucursal: id_sucursal,
        },
      })
  }

  function put (data){
    return $http.put('/api/contabilidad/cuentas-contables/sucursal', data)
  }

  function post (data){
    return $http.post('/api/contabilidad/cuentas-contables/sucursal', data)
  }

}


// WEBPACK FOOTER //
// ./src/contabilidad/catalogosexternos/services/sucursal/CatalogosExternosSucursalCuentasContables.js